import { render, staticRenderFns } from "./shortcut.vue?vue&type=template&id=5c2b0b62&scoped=true&"
import script from "./shortcut.vue?vue&type=script&lang=js&"
export * from "./shortcut.vue?vue&type=script&lang=js&"
import style0 from "./shortcut.vue?vue&type=style&index=0&id=5c2b0b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2b0b62",
  null
  
)

export default component.exports